<script>
export default {
    name: "tico-logo"
};
</script>

<template>
    <h1>
        <img
            src="../../assets/Logo-transparent.png"
            alt="TiCO2e Carbon Calculator. Tribally Invested Carbon Credits"
        >
    </h1>
</template>

<style scoped lang="less">
img {
    box-shadow: 0 0 50px white;
    background: white;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/tico-logo.vue